const getters = {
    labour: (state) => state.labour,
    loading: state => state.loading
};

export default getters;